exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Maps{height:100%;width:100%}.Maps text[font-family=Stanley]{font-family:Stanley,serif;font-weight:400}.Maps text[font-family=\"Roboto-Regular, Roboto\"]{font-family:Roboto,sans-serif;text-transform:uppercase}.Maps .slick-list,.Maps .slick-slider,.Maps .slick-track{height:100%;width:100%}.Maps .slick-dots{position:fixed;bottom:20px;z-index:9;pointer-events:none}.Maps .slick-dots li{pointer-events:all}.Maps .slick-dots li button:before{color:#fff;font-size:20px}.Maps .slick-dots li.slick-active button:before{color:#fff}.Maps__slide{height:100%;width:100%}.Maps__map{height:calc(100% - 90px);margin-bottom:40px;margin-top:50px;margin-right:8px;background-size:contain;background-position:50%;background-repeat:no-repeat}.Maps__map--westbank{background-image:url(\"/svg/mapWestbank.svg\")}.Maps__map--israel{background-image:url(\"/svg/mapIsrael.svg\")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/components/Navigation/Maps/Maps.scss
// module id = 290
// module chunks = 0